import * as React from 'react';

var _rect, _path, _rect2, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgMail = function SvgMail(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), _rect || (_rect = /*#__PURE__*/ React.createElement("rect", {
        width: 60,
        height: 46,
        x: 14,
        y: 21,
        fill: "url(#paint0_linear_1_42)",
        fillOpacity: 0.16,
        rx: 4
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_1_42)",
        d: "M14.615 63.333q-1.92 0-3.268-1.346T10 58.718V21.282q0-1.92 1.347-3.268t3.268-1.347h50.77q1.92 0 3.268 1.347T70 21.282v37.436q0 1.921-1.347 3.268t-3.268 1.347zm52.82-42.147L41.334 38.66a8 8 0 0 1-.657.292 1.9 1.9 0 0 1-.676.125 1.9 1.9 0 0 1-.676-.125 3.6 3.6 0 0 1-.593-.292L12.564 21.186v37.532q0 .898.577 1.474.577.577 1.474.577h50.77q.898 0 1.474-.577.577-.576.577-1.474zM40 36.564l26.27-17.333H13.813zm-27.436-14.73v-1.96.106-.75.7-.14z"
    })), _rect2 || (_rect2 = /*#__PURE__*/ React.createElement("rect", {
        width: 119,
        height: 187,
        x: -19.5,
        y: -19.5,
        stroke: "#9747FF",
        strokeDasharray: "10 5",
        rx: 4.5
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_1_42",
        x1: 14.627,
        x2: 73.165,
        y1: 44,
        y2: 44,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_1_42",
        x1: 10.627,
        x2: 69.165,
        y1: 40,
        y2: 40,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgMail as ReactComponent };
//# sourceMappingURL=Mail.svg.es.js.map
